// @flow

import React from 'react';
import styled from 'styled-components';
import Content from './content.styled';
import CollapseButton from './collapseButton';
import withCollapse from './withCollapse';
import type { Theme } from '../../../types';

const CollapseWrapper = styled<any, Theme>('div')`
  margin: 1rem 0 0;
`;

type Props = {
  onCollapse: Function,
  collapsed?: boolean,
  content: string,
  buttonTexts: {
    expanded: string,
    collapsed: string,
  },
};

const CollapsibleContent = ({
  onCollapse,
  collapsed,
  content,
  buttonTexts,
}: Props) => (
  <CollapseWrapper>
    {!collapsed && <Content className="content" dangerouslySetInnerHTML={{ __html: content }} />}
    <CollapseButton
      onClick={onCollapse}
      collapsed={collapsed}
    >
      {collapsed ? buttonTexts.collapsed : buttonTexts.expanded}
    </CollapseButton>
  </CollapseWrapper>
);

CollapsibleContent.defaultProps = {
  collapsed: false,
};

export default withCollapse<Props>(CollapsibleContent);
